/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Meta_TitleInputs */

const ja_playdata_home_meta_title = /** @type {(inputs: Playdata_Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`eスポーツ大会分析レポート`)
};

const en_playdata_home_meta_title = /** @type {(inputs: Playdata_Home_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA - Performance Reporting for Esports and Streaming`)
};

/**
* | output |
* | --- |
* | "PLAYDATA - Performance Reporting for Esports and Streaming" |
*
* @param {Playdata_Home_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_meta_title = /** @type {((inputs?: Playdata_Home_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_meta_title(inputs)
	return en_playdata_home_meta_title(inputs)
});